import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GetDataService } from './getdata.service';
import { AppLevelAccess } from '../models/models';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private defaultRange = this.getDefaultDateRange();
  private readonly storageKey = 'selectedDateRange';
  private dateRangeSubject = new BehaviorSubject<{ start: number; end: number } | null>(this.getStoredDateRange());
  dateRange$ = this.dateRangeSubject.asObservable();
    appLevelAccess:BehaviorSubject<AppLevelAccess[]>;
    currentBaseAppLevelAccess:BehaviorSubject<AppLevelAccess>;
    currentBaseId:BehaviorSubject<number>;

    assignedBases: BehaviorSubject<any>;
    constructor(private dataService:GetDataService,private cookieService:CookieService){
      this.assignedBases = new BehaviorSubject([]);
      const appLevelAccess:AppLevelAccess[] =[];
      this.appLevelAccess = new BehaviorSubject(appLevelAccess);
      const appLevelAccessValue:AppLevelAccess = {baseId:-1,accessLevel:{farmApp:null,warehouse:null,labApp:null,supplyDemand:null,
        qualityAccess:null,qualityInternalAccess:null,hseAccess:null,hseSummaryAccess:false,hseReportAccess:false
      }};
      this.currentBaseAppLevelAccess = new BehaviorSubject(appLevelAccessValue);
      this.setAssignedBases();
      this.currentBaseId = new BehaviorSubject(-1);
      const currentBaseId:any = localStorage.getItem('currentBaseId');
      if(currentBaseId && +currentBaseId !=-1){
        this.currentBaseId = new BehaviorSubject(+currentBaseId);
      }
    }
    setAssignedBases=()=>{
      let assignedBases:any = localStorage.getItem('assignedBases');
      assignedBases = assignedBases?JSON.parse(assignedBases):assignedBases;
      if(assignedBases && assignedBases.length>0){
        this.assignedBases.next(assignedBases);
      }
      else{
        this.dataService.getBaseId().subscribe(res=>{
          if(res && res.status_code==200 && res.data){
            assignedBases =[];
            const baseId = res.data.base_id?res.data.base_id.toString():'-1';
            assignedBases.push(baseId);
            this.assignedBases.next(assignedBases);
            localStorage.setItem('assignedBases',JSON.stringify(assignedBases));
          }
        },error=>{
          this.assignedBases.next([]);
        })
      }
    }

    setAppLevelAccess(appLevelAccess:AppLevelAccess[]){
      this.appLevelAccess.next(appLevelAccess);
    }
    setCurrentBaseAppLevelAccess(appLevelAccess:AppLevelAccess){
      this.currentBaseAppLevelAccess.next(appLevelAccess);
    }


    setBaseAccess(currentBaseId:number){
      const baseLevelAccess = this.cookieService.get('baseLevelAccess');
      if(baseLevelAccess){
        const baseLevelAccessJson:any = JSON.parse(baseLevelAccess);
        this.setAppLevelAccess(baseLevelAccessJson);
        if(baseLevelAccessJson && baseLevelAccessJson.length>0){
          const currentIndex = baseLevelAccessJson.findIndex((item:any)=>item.baseId == currentBaseId);
          if(currentIndex !=-1){
            this.setCurrentBaseAppLevelAccess(baseLevelAccessJson[currentIndex]);
          }
        }
      }
      else{
        const matiAdminEmail:any = localStorage.getItem('mati_admin_email');
        this.dataService.checkAdminExistence(matiAdminEmail).subscribe(response=>{
          if(response && response.data && response.data.length>0){
            const baseLevelAcessObj = response.data[0].base_details;
            if(baseLevelAcessObj){
              let appLevelAccess: AppLevelAccess[]=[];
              baseLevelAcessObj.forEach((item:any)=>{
                appLevelAccess.push({baseId:item.base_id,accessLevel:{farmApp:item.farm_app_access,warehouse:item.warehouse_app_access,
                  labApp:item.lab_app_access,supplyDemand:item.supply_demand_access,
                  qualityAccess:item.quality_system_access,qualityInternalAccess:item.quality_system_edit_internal_access,
                  hseAccess:item.hse_system_access,
                  hseSummaryAccess:item.hse_system_access == 'e'?true:item.hse_summary_view,
                  hseReportAccess:item.hse_system_access == 'e'?true:item.hse_report_view
                }});
              });
              this.setAppLevelAccess(appLevelAccess);
              this.cookieService.set('baseLevelAccess',JSON.stringify(appLevelAccess));
              if(appLevelAccess && appLevelAccess.length>0){
                const currentIndex = appLevelAccess.findIndex(item=>item.baseId == currentBaseId);
                if(currentIndex !=-1){
                  this.setCurrentBaseAppLevelAccess(appLevelAccess[currentIndex]);
                }
              }
            }
  
            // ask for current base access switch
  
          }
        })
      }
    }

  transformDate(inputDate:any){
    let date:any;
    // Check if the input is a timestamp (number) or a date string
    if (inputDate && !isNaN(inputDate)) {
      date = new Date(+inputDate);
    } else {
      return inputDate;
    } 
    // Format the date as 'dd/mm/yyyy'
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const year = date.getUTCFullYear();
    return `${day}-${month}-${year}`;
  }
  transformDateTime(inputDate:any){
    let date:any;
    // Check if the input is a timestamp (number) or a date string
    if (inputDate && !isNaN(inputDate)) {
      date = new Date(+inputDate);
    } else {
      return inputDate;
    } 
    // Format the date as 'dd/mm/yyyy'
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const year = date.getFullYear();
    let hours = date.getHours();
    let mins = date.getMinutes();
    let ampm = hours >= 12 ? 'PM' : 'AM';
    // Convert hours from 24-hour format to 12-hour format
    hours = hours % 12; // Convert to 12-hour format
    hours = hours ? hours : 12; // Handle midnight (0 should become 12)
    mins = mins < 10 ? '0' + mins : mins; // Format minutes to two digits
    return `${day}-${month}-${year}  ${hours}:${mins} ${ampm}`;
  }
  transformTime(inputDate:any){
    let date:any;
    // Check if the input is a timestamp (number) or a date string
    if (inputDate && !isNaN(inputDate)) {
      date = new Date(+inputDate);
    } else {
      return inputDate;
    } 
    let hours = date.getUTCHours();
    let mins = date.getUTCMinutes();
    let ampm = hours >= 12 ? 'PM' : 'AM';
    // Convert hours from 24-hour format to 12-hour format
    hours = hours % 12; // Convert to 12-hour format
    hours = hours ? hours : 12; // Handle midnight (0 should become 12)
    mins = mins < 10 ? '0' + mins : mins; // Format minutes to two digits
    return ` ${hours}:${mins} ${ampm}`;
  }
  // Update the date range and store in localStorage
  updateDateRange(start: number, end: number): void {
    console.log('inside update date range',start,end);
    const range = { start, end };
    localStorage.setItem(this.storageKey, JSON.stringify(range));
    setTimeout(() => this.dateRangeSubject.next(range), 0); 
    // Ensure emission happens after storage update
  }

  // Get stored date range from localStorage
  private getStoredDateRange(): { start: number; end: number } | null {
    const stored = localStorage.getItem(this.storageKey);
    return stored ? JSON.parse(stored) : this.defaultRange;
  }

  // Default range: Last 6 months to current date
  private getDefaultDateRange(): { start: number; end: number } {
    const now = new Date();
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(now.getMonth() - 6);

    return {
      start: sixMonthsAgo.getTime(), // 6 months ago
      end: now.getTime() // Current time
    };
  }
}